import ExaminationQuestionGroups from './ExaminationQuestionGroups';

export default ExaminationQuestionGroups;
